/* esm.sh - unhead@2.1.12/plugins */
export * from "/*unhead@2.1.12/esnext/plugins.mjs";
